/* eslint-disable max-len */
export function IconSidebar({ className }: { className?: string }) {
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M15.1399 0H2.86005C1.28292 0 0 1.28285 0 2.86005V15.1399C0 16.7171 1.28285 18 2.86005 18H9H15.1399C16.7171 18 18 16.7172 18 15.1399V2.86005C18 1.28292 16.7172 0 15.1399 0ZM1.42866 15.1399V2.86005C1.42866 2.07149 2.0715 1.42864 2.86007 1.42864H5.68008V16.5713H2.86007C2.0715 16.5713 1.42866 15.9285 1.42866 15.1399ZM16.5713 15.1399C16.5713 15.9285 15.9285 16.5714 15.1399 16.5714H7.10852V1.42867H15.1399C15.9285 1.42867 16.5713 2.07152 16.5713 2.86009V15.1399Z"
        fill="currentColor"
      />
    </svg>
  );
}

export function IconFullscreen({ className }: { className?: string }) {
  return (
    <svg
      width="15"
      height="14"
      viewBox="0 0 15 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M2.0498 6.34961V11.9502H7.65039V13.6504H0.349609V6.34961H2.0498Z"
        fill="currentColor"
        stroke="currentColor"
        strokeWidth="0.3"
      />
      <path
        d="M12.9502 7.65039L12.9502 2.0498L7.34961 2.04981L7.34961 0.34961L14.6504 0.349609L14.6504 7.65039L12.9502 7.65039Z"
        fill="currentColor"
        stroke="currentColor"
        strokeWidth="0.3"
      />
    </svg>
  );
}

export function IconMinimize({ className }: { className?: string }) {
  return (
    <svg width="14" height="2" viewBox="0 0 14 2" fill="none" xmlns="http://www.w3.org/2000/svg" className={className}>
      <rect width="14" height="2" fill="currentColor" />
    </svg>
  );
}

export function IconBell({ className }: { className?: string }) {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M8 16C9.1 16 10 15.1 10 14H6C6 15.1 6.9 16 8 16ZM14 10V6.5C14 4.02 12.49 1.89 10 1.18V0.5C10 -0.17 9.33 -0.5 8 -0.5S6 -0.17 6 0.5V1.18C3.51 1.89 2 4.02 2 6.5V10L0 12V13H16V12L14 10ZM12 11H4V6.5C4 4.57 5.57 3 8 3S12 4.57 12 6.5V11Z"
        fill="currentColor"
      />
    </svg>
  );
}

export function IconBellOff({ className }: { className?: string }) {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M8 16C9.1 16 10 15.1 10 14H6C6 15.1 6.9 16 8 16ZM14 10V6.5C14 4.02 12.49 1.89 10 1.18V0.5C10 -0.17 9.33 -0.5 8 -0.5S6 -0.17 6 0.5V1.18C3.51 1.89 2 4.02 2 6.5V10L0 12V13H16V12L14 10ZM12 11H4V6.5C4 4.57 5.57 3 8 3S12 4.57 12 6.5V11Z"
        fill="currentColor"
        opacity="0.4"
      />
      <path d="M2 1L1 2L15 16L16 15L2 1Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
    </svg>
  );
}
